import {globals} from "../../../core/utils/globals";
import {newLogger} from "../../../core/utils/logger";
import {Settings} from "./model/settings";
import {DebugInfo} from "./model/debuginfo";

const logger = newLogger('Shop');

export const shopData = {
	categories: [],
	categoryGroups: [],

	...globals('shopData')
};
logger.log('data', shopData);

/** @type {Settings} */
export const settings = new Settings(globals('shopSettings'));
logger.log('settings', settings);

/** @type {DebugInfo} */
export const debugInfo = new DebugInfo();

// todo: move this code out of here
// force offer links open in new window
(function () {
	const url = settings.getOfferUrl('');
	$(document).on('click', `a[href^="${url}"]:not([target])`, function (e) {
		if (!e.isDefaultPrevented()) {
			e.preventDefault();
			window.open($(this).attr('href'));
		}
	});
})();



// WEBPACK FOOTER //
// ./modules/shop/common/data.js